export const backend_url = 'https://cognivision-be.citriot.ai/api/vision/v1'
export const backend_url_dash = 'https://cognivision-be.citriot.ai/api/vision/v2'
// export const backend_url = 'http://localhost:8000/api/vision/v1';
// export const backend_url_dash = 'http://localhost:8000/api/vision/v2';

export const backend_stream_url = "https://cognivision-be.citriot.ai"
// export const backend_stream_url = "http://localhost:8000"
export const webSocketUrl = "wss://cognivision-be.citriot.ai/ws"
// export const webSocketUrl = 'ws://localhost:8000/ws';
// export const lakeshoreWebSocketUrl = "wss://cognivision-be.citriot.ai/lakeshore-ws";
// export const lakeshoreWebSocketUrl = "ws://localhost:8000/lakeshore-ws";


